import { Dispatch, createContext } from "react"
import { Lesson } from "shared/lessons"
import { LessonVariety, Type } from "shared/types/moduleTypes"
import { BlockType } from "shared/types/science35Types"

export type AssignmentSection = "topic" | "lesson" | "assessment" | "completed"
export type AssignmentContextType = {
    moduleName: string
    type: Type
    lessonVariety: LessonVariety
    guidedLesson: Lesson
    activePart: AssignmentSection
    setActivePart: (activePart: AssignmentSection) => void
    setOnReturn?: Dispatch<any>
    restartAssignment?: () => Promise<void>
    assessmentOnly: boolean
    submissionId?: string
    demoMode: boolean
    reworkAssignmentMode: boolean
    isReview: boolean
    block?: BlockType
}

export const AssignmentContext = createContext<AssignmentContextType>({
    activePart: "lesson",
    setActivePart: () => {},
    restartAssignment: () => Promise.resolve(),
    guidedLesson: null,
    moduleName: null,
    type: null,
    lessonVariety: null,
    assessmentOnly: false,
    submissionId: null,
    demoMode: false,
    reworkAssignmentMode: false,
    isReview: false
})
